import { IAuth } from 'interface/auth';
import { COOKIE_DOMAIN, IS_PROD } from 'settings';
import tokenService from 'services/token';
import { appPostMessage } from 'utils';

const initialState: IAuth = {
  isFetching: false,
  isAuthenticated: tokenService.isAuthenticated(),
  isFetchingTenant: false,
  tenantId: tokenService.getTenantId(),
  refreshToken: tokenService.getRefreshToken(),
};

const auth = (state: IAuth = initialState, action: any): IAuth => {
  switch (action.type) {
    case 'REQUEST_LOGIN':
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        tenantId: null,
        isFetchingTenant: false,
        tenantError: null,
      };
    case 'RECEIVE_LOGIN':
      tokenService.updateToken(action.token, action.refreshToken);
      appPostMessage('auth', { token: action.token, refreshToken: action.refreshToken });
      tokenService.setUserByToken(action.token);
      return {
        ...state,
        isFetching: false,
        shouldRedirectHome: false,
        isAuthenticated: true,
        refreshToken: action.refreshToken,
        tenantId: null,
        isFetchingTenant: false,
        tenantError: null,
      };
    case 'RECEIVE_LOGIN_ERROR':
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
      };
    case 'REQUEST_TENANT':
      return {
        ...state,
        isFetchingTenant: true,
        tenantError: null,
        tenantId: null,
      };
    case 'RECEIVE_TENANT':
      tokenService.updateToken(action.token);
      return {
        ...state,
        tenantId: action.id,
        isFetchingTenant: false,
      };
    case 'RECEIVE_TENANT_ERROR':
      return {
        ...state,
        tenantError: action.error,
        isFetchingTenant: false,
      };
    case 'LOGOUT':
      localStorage.removeItem('newAuthToken');
      localStorage.removeItem('refreshToken');

      window.document.cookie = `userSession=; domain=${COOKIE_DOMAIN}; path=/`;

      appPostMessage('auth', { token: null, refreshToken: null });

      (window as any).Eduzz.Accounts.logout({
        redirectTo: window.location.origin + (action.redirectTo || ''),
        env: !IS_PROD ? 'qa' : '',
      });

      return state;
    default:
      return state;
  }
};

export default auth;
